/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_FloorInputs */

const cs_form_floor = /** @type {(inputs: Form_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podlaží`)
};

const en_form_floor = /** @type {(inputs: Form_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floor`)
};

/**
* | output |
* | --- |
* | "Floor" |
*
* @param {Form_FloorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_floor = /** @type {((inputs?: Form_FloorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_FloorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_floor(inputs)
	return cs_form_floor(inputs)
});